import sync from './sync';
import authorize from './authorize';

export default {
  sync,
  authorize,
};



// WEBPACK FOOTER //
// ./src/app/services/poweroffice/index.js